import { render, staticRenderFns } from "./PaymentsForpay.vue?vue&type=template&id=e1687700&scoped=true&"
import script from "./PaymentsForpay.vue?vue&type=script&lang=js&"
export * from "./PaymentsForpay.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsForpay.vue?vue&type=style&index=0&id=e1687700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1687700",
  null
  
)

export default component.exports